export const OFFICE_ALLOWED_ROUTES = ['/office', '/error'];
